import React, { Component } from "react";
import "./Crcl.css";

import Header from "../../components/Header/Header";
import Welcome from "../../containers/Crcl/Welcome/Welcome";
import Calculator from "../../containers/Crcl/Calculator/Calculator";
import Results from "../../containers/Crcl/Results/Results";
import Footer from "../../components/Footer/Footer";
import AlertDialog from "../../components/AlertDialog/AlertDialog";
import { Route } from "react-router-dom";
import CrclProvider from "./contexts/CrclProvider";
import CrclContext from "./contexts/CrclContext";

class Crcl extends Component {
  render() {
    return (
      <div className="Crcl-app">
        <Header title="Creatinine Clearance and Enoxaparin (Clexane) dose calculator" />
        {/* <CrclProvider> */}
          <AlertDialog />
          <Route path="/" exact component={Welcome} />
          <Route path="/calculator" exact component={Calculator} />
          <Route path="/results" exact component={Results} />
        {/* </CrclProvider> */}
        <Footer />
      </div>
    );
  }
}

// Calculator.contextType = CrclContext;

export default Crcl;
